import React, { useContext } from "react";
import Ctagirl from "../../../../images/LandingPageImage/wosender_cta__1x.webp";
import "../designcss/Getstartednow.css";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const CallToAction = () => {
  // const navigate = useNavigate();
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <div className="getstartedwrapper">
      <section className="cta-section">
      <div className="cta-card">
        <div className="cta-grid">
          {/* LEFT CONTENT */}
          <div className="cta-left">
            <div className="cta-badge">
              <p>Get Started Now</p>
            </div>

            <p className="cta-title">
              Chat with SleekFlow AI agent, created with pride using AgentFlow
            </p>

            <div className="cta-buttons">
              <button
              onClick={openFreeTrialModal} className="cta-btn-primary">Start Free Trial</button>
              <Link to="/pricing-section">
              <button className="cta-btn-outline">See Pricing</button>
              </Link>
          
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="cta-right">
            <img src={Ctagirl} alt="feature" className="cta-image" />
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default CallToAction;
